<form [formGroup]="componentForm" style="height: 100%;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" >
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Zip files
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke"
                        style="min-height: unset; height: 100%;"
    >
      <mat-form-field appearance="outline" color="accent" style="width: 100%">
        <mat-label>Zip name</mat-label>
        <input matInput id="zip-name-input" type="text"
               (keydown)="handleKeyDown($event)" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
               cdkFocusInitial formControlName="zipName">
      </mat-form-field>
      <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
           *ngIf="validationResult && !validationResult.isValid && validationResult.message">
        <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message}}</span>
      </div>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        Make Zip
      </button>
    </div>
  </div>
</form>